/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/input/custom-elements';

import { defineCustomElement as defineOsdsInput } from '@ovhcloud/ods-stencil/components/input/custom-elements/osds-input.js';


export const OsdsInput = /*@__PURE__*/ defineContainer<JSX.OsdsInput>('osds-input', defineOsdsInput, [
  'ariaLabel',
  'ariaLabelledby',
  'clearable',
  'color',
  'contrasted',
  'defaultValue',
  'disabled',
  'error',
  'errorStateControl',
  'flex',
  'forbiddenValues',
  'formControl',
  'icon',
  'label',
  'loading',
  'masked',
  'max',
  'min',
  'name',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'step',
  'type',
  'value',
  'odsValueChange',
  'odsInputBlur',
  'odsInputFocus'
]);

